import { render, staticRenderFns } from "./ListBuyBox.vue?vue&type=template&id=6c34bb99&scoped=true"
import script from "./ListBuyBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListBuyBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ListBuyBox.vue?vue&type=style&index=0&id=6c34bb99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34bb99",
  null
  
)

export default component.exports